import {
  AWFExecute,
  AWFMenu,
  AWFMenuItem,
} from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../../contributions.enum';
import { Icons, IconType } from '@ansys-internal/awc-angular/icons';
import {
  DashboardTables,
  FilesMoreMenu,
  SelectedProjectState,
} from '@ansys-internal/awf-angular/dashboard';
import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import {
  AWFFile,
  AWFProjectData,
  FileCreateRequest,
  DialogService,
  ProductContextService,
  SnackBarService,
  TableRefreshDataAction,
} from '@ansys-internal/awf-angular/shared';
import { DesignApiService } from '@ansys/cloud-angular-client';
import { CreateProjectComponent } from '../../../../components/dialogs/create-project/create-project.component';
import { lastValueFrom } from 'rxjs';
import { ConceptService } from '../../../../shared/services/concept.service';
import { State } from '@ansys-internal/awf-angular/store';
import { LoadingComponent } from '../../../../components/dialogs/loading/loading.component';
import { FilesTableExportDesignMenuItem } from './files-table-export-design.menu-item';

@AWFMenuItem({
  id: ContributionsEnum.FILES_TABLE_CREATE_PROJECT_FROM_DESIGN_MENU_ITEM,
  priority: 150,
})
export class FilesTableCreateProjectFromDesign implements AWFExecute<any> {
  id: string =
    ContributionsEnum.FILES_TABLE_CREATE_PROJECT_FROM_DESIGN_MENU_ITEM;
  priority: number = 150;
  prefixIcon: IconType = { icon: Icons.PERIODIC };
  text: string = 'Duplicate to new project';

  constructor(
    private actions: ActionContributionsService,
    private snackbar: SnackBarService,
    private dialogService: DialogService,
    private conceptService: ConceptService,
    private designApi: DesignApiService,
    private productService: ProductContextService,
    private state: State
  ) {}

  async execute(design: AWFFile): Promise<void> {
    this.dialogService.open(CreateProjectComponent, {
      title: 'Create Project',
      data: {
        callback: async (project: AWFProjectData) => {
          if (!project) {
            return;
          }
          const loadingDialog = this.dialogService.open(LoadingComponent, {
            title: 'Duplicating File',
          });

          try {
            this.state.set(SelectedProjectState, project);
            this.actions.execute(TableRefreshDataAction, DashboardTables.FILES);

            const productId = (await this.productService.getProduct())
              ?.partNumber;
            const request: FileCreateRequest = {
              projectId: project.projectId,
              productId,
              designTitle: design.designTitle,
              designDescription: design.designDescription,
              designGoal: design.designGoal,
            };

            const instance = await lastValueFrom(
              this.designApi.designCreateHandler(request as FileCreateRequest)
            );

            const newInstance = {
              ...instance,
              designInstanceList: instance.designInstanceList?.map(
                (designInstance, index) =>
                  index === 0
                    ? {
                        ...designInstance,
                        parentDesignInstanceId:
                          design.designInstanceList?.[0]?.designInstanceId ??
                          undefined,
                      }
                    : designInstance
              ),
            };

            await lastValueFrom(
              this.conceptService.cloneConcept(newInstance, true)
            );
            await this.actions.execute(
              TableRefreshDataAction,
              DashboardTables.FILES
            );

            this.snackbar.success('File Duplicated to new Project');
          } catch (error) {
            console.error('Error duplicating file:', error);
            this.snackbar.error('Failed to duplicate file');
          } finally {
            loadingDialog.close();
          }
        },
      },
    });
  }
}
